/// <reference path="appbase.ts" />


namespace TerminalApp {
	let appId = "app_receive_transfer";

	export class transfer_item {
		container: HTMLElement;
		selected: boolean;
		line: SP.PackageLine;
		dood: SP.CheckboxDoodle;
		itemInfo: SP.ItemInfo;

		select(selected: boolean) {
			this.container.style.opacity = selected ? "1" : "0.5";
			this.selected = selected;
			this.dood.checked = selected;
		}

		constructor(i: SP.PackageLine, itemInfo: SP.ItemInfo) {
			console.log(i);
			this.line = i;
			this.itemInfo = itemInfo;
			let name = `${itemInfo.manufacturerName} ${itemInfo.modelNo}`.trim();

			//elm
			let item = this.container = document.createElement("div");
			item.classList.add("item");

	
			if (itemInfo.barcodes == undefined) itemInfo.barcodes = [];
			//let numMin = Math.pow(10, 12);
			//let numMax = numMin * 9 - 1;
			//while (itemInfo.barcodes.length < 5) {
			//	itemInfo.barcodes.push(Math.floor(Math.random() * numMax + numMin).toString())
			//}

			let checked = "";
			let disabled = "";
			if (i.transferCompletedAt) {
				//checked = "checked";
				disabled = "disabled";
			}

			//tempalte
			item.innerHTML = `
					<input type="checkbox" value="${i.id}" ${checked} ${disabled} name="skus" class="msq_sku_checkbox">
					<div class="image">
						<img src="${itemInfo.imageUrl}">
					</div>
					<div class="description-box">
						<div class="heading">
							<b>${itemInfo.sku} ${((name ? ` (${name})` : ""))}</b>
							<span class="eans">
								${itemInfo.barcodes?.join(', ') ?? ''}
							</span>
						</div>
						<div class="description">
							<span>${itemInfo.description}</span>
						</div>
					</div>
					<div class="label label_input">
						<input type="number" class='count_input' disabled id="ts_count_${i.id}" value="${i.quantity}">
					</div>`;


		

			if (i.transferCompletedAt) {
				item.innerHTML += `<div class="received">${SP.Localize('word_received')}: ${i.transferCompletedAt}</div>`
			}

			//click for item info
			let image_span = item.querySelector(".image");
			image_span.addEventListener("click", (e) => {
				itemShortcutAssistant.open_with_info(itemInfo);
				e.preventDefault(); e.stopPropagation();
			});

			//Create checkbox doodle
			let checkbox = item.querySelector(".msq_sku_checkbox") as HTMLInputElement;
			this.dood = new SP.CheckboxDoodle(checkbox);
			if (disabled == "disabled") this.dood.disabled = true;
			console.log("disabled:", disabled);
			this.dood.onChange = () => {
				this.select(checkbox.checked);
				app_receive_transfer.instance.updateResetSelect();
			};




			this.select(false);
		}

	
	}

	export class app_receive_transfer extends AppBase {

		rt_scan_package = document.getElementById("rt_scan_package");
		rt_scan_location = document.getElementById("rt_scan_location");
		rt_content = document.getElementById("rt_content");
		rt_received = document.getElementById("rt_received");
		rt_content_items = this.rt_content.querySelector(".items");
		rt_received_items = this.rt_received.querySelector(".items");
		allRecievedInfo: HTMLElement = this.rt_content.querySelector(".all_received");
		rt_sender_location = document.getElementById("rt_sender_location");
		rt_recipient_location = document.getElementById("rt_recipient_location");
		rt_order_no = document.getElementById("rt_order_no");
		rt_reset_all = document.getElementById("rt_reset_all");
		rt_select_all = document.getElementById("rt_select_all");
		currentPackage: SP.PackageTransferInfo;
		assistant: TransferPackageAssistant;


		bound = false;
		static instance: app_receive_transfer;




		constructor() {
			super(appId);
			app_receive_transfer.instance = this;

			this.rt_scan_location.addEventListener("click", () => {
				placementPickerAssistant.open(null, null, (p) => {
					this.scanPlacement(p.id.toString());
				});
			});

			this.rt_select_all.addEventListener("click", () => {
				this.selectAll(true);
			});

			this.rt_reset_all.addEventListener("click", () => {
				this.selectAll(false);
			});

			//assistant
			this.assistant = new TransferPackageAssistant();
			this.container.appendChild(this.assistant.container);


			document.getElementById("rt_scan_package").addEventListener("click", async (e: MouseEvent) => {
				var barcode = await this.assistant.open()
				if (barcode) {
					this.scanBarcode(barcode);
				}
			});
		}
		reset() {
			this.allRecievedInfo.style.display = "none";
			this.items = [];
			this.rt_scan_package.style.display = "block";
			this.rt_scan_location.style.display = "none";
			this.rt_content.style.display = "none";
			this.rt_content_items.innerHTML = "";
			this.rt_received.style.display = "none";
			this.rt_received_items.innerHTML = "";
			this.currentPackage = undefined;
		}

		selectAll(select: boolean) {
			for (var i = 0; i < this.items.length; i++) {
				let item = this.items[i];
				if (item.line.transferCompletedAt) continue;
				if (!item.selected && select) {
					item.select(true);
				}
				else if (item.selected && !select) {
					item.select(false);
				}
			}	
			this.updateResetSelect();
		}



		updateResetSelect() {
			var showReset = false;
			var showSelect = false;
			for (var i = 0; i < this.items.length; i++) {
				let item = this.items[i];
				if (item.line.transferCompletedAt) continue;
				if (item.selected) showReset = true;
				else showSelect = true;
				if (showReset && showSelect) break;
			}

			this.rt_reset_all.style.display = showReset ? "" : "none";
			this.rt_select_all.style.display = showSelect ? "" : "none";
		}


		async scanBarcode(bc: string) {
			
			var data = await SP.Data.Transfer.getPackageTransferInfo(bc);

			if (data.match) {
				this.reset();
				this.selectPackage(data);
				//this.populate(data);
			}
			else {
				for (var i = 0; i < this.items.length; i++) {
					console.log(this.items[i].itemInfo.allBarcodes);
					if (GetBarcodeQty(this.items[i].itemInfo.allBarcodes, bc) > 0) {
						SP.Sounds.Click.play();
						this.items[i].dood.checked = true;
						this.items[i].dood.onChange();
						return;
					}
				}

				SP.alertX("Transfer or item not found for barcode: " + bc);
			}
		}

		items: transfer_item[] = [];


		scanning: boolean = false;
		async scanPlacement(placementId: string) {
			if (this.scanning) return;
			if (!placementId) return;
			this.scanning = true;
			try {
				console.log("scanning placement", placementId);
				console.log(this.items);
				if (this.items.filter(i => i.selected == true).length == 0) {
					SP.alertX("No items selected");
					return;
				}

				return await this.performArrival(placementId);
			} catch(e) {
				SP.Sounds.Error.play();
				SP.alertX("Error: " + e);
				console.error(e);
			} finally {
				this.scanning = false;
			}
		}
		async performArrival(placementId: string) {
			console.log("performArrival", placementId);
			var result = await SP.post<any>("/api/v1/transfer/update", {
				"packageId": this.currentPackage.package.id,
				"lines": this.items.filter(i => i.selected).map(i => i.line.id),
				"placementId": placementId
			});
			if (result.status == 200) {
				SP.Sounds.Success.play();

				//re-render
				this.scanBarcode(SP.getHash("packageId"))

				//this.currentPackage.package.lines.forEach(i => {
				//	if (this.itemValidated.indexOf(i.dood.checkbox) == -1) return;
				//	if (i.dood) i.dood.disabled = true;
				//});
			} else {
				SP.Sounds.Error.play();
				SP.alertX("Error: " + result.msg);
				console.log(result);
			}
		}

		async selectPackage(info: SP.PackageTransferInfo) {
			ignoreHashChange = true;
			SP.setHash("packageId", info.package.id);
			this.rt_scan_location.style.display = "block";
			this.rt_content.style.display = "";
			this.rt_scan_package.style.display = "none";


			this.rt_sender_location.innerHTML  = info.fromLocationName;
			this.rt_recipient_location.innerHTML = info.toLocationName;
			this.rt_order_no.innerHTML = info.orderNo;


			var pending = false;
			var recievedSomething = false;
			info.package.lines.forEach(i => {
				let itemInfo = info.itemInfos[i.id];
				var elm = new transfer_item(i, itemInfo);
				this.items.push(elm);

				
				if (i.transferCompletedAt) {
					this.rt_received_items.appendChild(elm.container);
					recievedSomething = true;
				}
				else {
					this.rt_content_items.appendChild(elm.container);
					pending = true;
				}

			});

			if (!pending) this.allRecievedInfo.style.display = "block";
			if (recievedSomething) this.rt_received.style.display = "block";

			this.currentPackage = info;
			this.updateResetSelect();

		}

		async onOpen() {
			this.reset();

			//bind events and groups
			if (!this.bound) {
				this.bound = true;
				barcodeListener.on("sp", this.scanPlacement, this);
				barcodeListener.on(null, this.scanBarcode, this);
			}

			var packageId = SP.getHash("packageId");

			//load package
			if (packageId) await this.scanBarcode(packageId);

		}

		async onClose() {
			//unbind events and groups
			if (this.bound) {
				this.bound = false;
				barcodeListener.off("sp", this.scanPlacement);
				barcodeListener.off(null, this.scanBarcode);
			}
			this.reset();
		}
	}

	RegisterApp(appId, app_receive_transfer);
}